export default [
  {
    word: 'Achievement',
    id: 1000,
  },
  {
    word: 'Adaptability',
    id: 1010,
  },
  {
    word: 'Adventure',
    id: 1020,
  },
  {
    word: 'Beauty',
    id: 1030,
  },
  {
    word: 'Compassion',
    id: 1040,
  },
  {
    word: 'Cooperation',
    id: 1050,
  },
  {
    word: 'Duty',
    id: 1060,
  },
  {
    word: 'Excitement',
    id: 1070,
  },
  {
    word: 'Effectiveness',
    id: 1080,
  },
  {
    word: 'Nature',
    id: 1090,
  },
  {
    word: 'Loyalty',
    id: 1100,
  },
  {
    word: 'Love',
    id: 1110,
  },
  {
    word: 'Fame',
    id: 1120,
  },
  {
    word: 'Family',
    id: 1130,
  },
  {
    word: 'Friendship',
    id: 1140,
  },
  {
    word: 'Freedom',
    id: 1150,
  },
  {
    word: 'Fun',
    id: 1160,
  },
  {
    word: 'Faith',
    id: 1170,
  },
  {
    word: 'Honesty',
    id: 1180,
  },
  {
    word: 'Stability',
    id: 1190,
  },
  {
    word: 'Humility',
    id: 1200,
  },
  {
    word: 'Independence',
    id: 1210,
  },
  {
    word: 'Acceptance',
    id: 1220,
  },
  {
    word: 'Mentorship',
    id: 1230,
  },
  {
    word: 'Justice',
    id: 1240,
  },
  {
    word: 'Knowledge',
    id: 1250,
  },
  {
    word: 'Leisure',
    id: 1260,
  },
  {
    word: 'Mastery',
    id: 1270,
  },
  {
    word: 'Individualism',
    id: 1280,
  },
  {
    word: 'Hard Work',
    id: 1290,
  },
  {
    word: 'Openness',
    id: 1300,
  },
  {
    word: 'Whimsy',
    id: 1310,
  },
  {
    word: 'Order',
    id: 1320,
  },
  {
    word: 'Pleasure',
    id: 1330,
  },
  {
    word: 'Popularity',
    id: 1340,
  },
  {
    word: 'Power',
    id: 1350,
  },
  {
    word: 'Perfection',
    id: 1360,
  },
  {
    word: 'Rationality',
    id: 1370,
  },
  {
    word: 'Respectability',
    id: 1390,
  },
  {
    word: 'Responsibility',
    id: 1400,
  },
  {
    word: 'Truth',
    id: 1410,
  },
  {
    word: 'Thrill Seeking',
    id: 1420,
  },
  {
    word: 'Self-Knowledge',
    id: 1430,
  },
  {
    word: 'Solitude',
    id: 1440,
  },
  {
    word: 'Service',
    id: 1450,
  },
  {
    word: 'Virtue',
    id: 1460,
  },
  {
    word: 'Wealth',
    id: 1470,
  },
  {
    word: 'Disruption',
    id: 1480,
  },
];




// WEBPACK FOOTER //
// ./src/fixtures/refinedvalues.js